export default {
    header: {
        title: "Let's Build your Review Questionnaire",
        description:
            'To ensure the success of your reviews, you must also communicate them in advance',
        preview: 'Preview',
        selectNewTemplate: 'Select a new template',
        actions: {
            importQuestions: 'Import Questions',
            exportQuestions: 'Export Questions',
            deactivateAllQuestions: 'Deactivate All Questions',
            activateAllQuestions: 'Activate All Questions',
        },
        marketingSurvey: 'Marketing Evaluation',
        questionPlaceholder: 'What topics would you need more information on?',
    },
    toolbar: {
        addQuestion: 'Add Question',
    },
    questionForm: {
        title: 'Add a New Question',
        titleEdit: 'Edit Question',
        allowComments: 'Allow Comments',
        selectQuestionPlaceholder: 'Select Question',
        companyValue: {
            assignToEnterpriseValue: 'Assign to an enterprise value',
            measuringAdherenceToValues: 'Measuring adherence to values',
            selectValue: 'Select a value',
            noActiveValuesAvailable: 'No active company values available',
        },
        filters: {
            advancedOptions: 'Advanced Options',
            questionType: 'Question type',
        },
        advancedOptions: {
            conditionalToAnotherQuestion: 'This question is conditional to another question',
            doNotAllowSkip: 'Do not allow the employee to skip this question',
            doNotIncludeInScore: 'Do not include this question in score calculation',
        },
        questions: {
            common: {
                stronglyAgree: 'Strongly Agree',
                stronglyDisagree: 'Strongly Disagree',
                otherOptionLabel: 'Add the option: Other',
            },
            likertScale: {
                stronglyAgree: 'Strongly agree',
                somewhatAgree: 'Somewhat agree',
                neutral: 'Neutral',
                somewhatDisagree: 'Somewhat disagree',
                stronglyDisagree: 'Strongly disagree',
            },
            placeholder: 'What topics would you need more information on ?',
            plainText: {
                title: 'Plain Text',
            },
            yesno: {
                title: 'Yes or No',
            },
            rating: {
                title: 'Rating Scale',
                longTitle: 'Rating Scale Format',
            },
            multipleChoice: {
                title: 'Multiple choices',
                longTitle: 'Multiple choices Format',
                description:
                    "The first option is the most favorable option, and the last must be the least favorable one. The options' order is used to calculate the score.",
            },
            ranking: {
                title: 'Ranking',
                longTitle: 'Drag and Drop Format',
                description:
                    'Please note that the order of the options below is the same as what employees will see in the survey interface.',
                optionLabel: 'Option',
            },
            checkbox: {
                title: 'Checkboxes',
                longTitle: 'Checkboxes Format',
                description:
                    'Please note that the order of the options below is the same as what employees will see in the survey interface.',
                maximumChoicesLabel: 'Maximum number of choices',
            },
            emojiChoice: {
                title: 'Smiley options',
                longTitle: 'Smiley options Format',
            },
            section: {
                title: 'Section title',
            },
        },
    },
    rankingQuestion: {
        nextElementToRank: 'Rank the next element',
        yourRanking: 'Your Ranking',
        dragDropTip: '(Hold and drag the item into the table below)',
        addToRanking: 'Add to Ranking',
        helpText: 'Get help with the drag & drop feature',
        helpModalTitle: 'Drag & drop help',
        helpModalText:
            "Here's a sample video demonstrating how to drag and drop your items into the designated box.",
        helpModalImageAlt: 'Drag and drop demonstration',
    },
    editQuestion: {
        title: 'Edit Question',
        allowComments: 'Allow Comments',
    },
    validation: {
        checkboxMinOptions: 'Checkbox questions must have at least 2 options',
        maximumChoicesMin: 'Maximum choices must be at least 1',
        maximumChoicesMax: 'Maximum choices cannot exceed the total number of options',
        maximumChoicesRequired: 'Maximum number of choices is required',
        questionLabelRequired: 'Question title is required',
        questionLabelMin: 'Question title must be at least 3 characters long',
        optionLabelRequired: 'Option label is required',
        questionnaireTitleMin: 'Questionnaire title must be at least 3 characters long',
        ratingScaleExactOptions: 'Rating scale questions must have exactly 2 options',
        ratingScaleOrder: 'Rating scale "from" value must be less than "to" value',
        managerSkillSelectorRequired:
            'Please select which competencies should be assessed for {{managerLabel}} evaluations.',
        ratingScaleBoundsInvalid:
            'Rating scale "from" and "to" must be whole numbers, and "from" cannot be negative.',
        scaleLabelRequired: 'Both scale labels (low and high) are required.',
        multipleChoiceMinOptions: 'This question must have at least two options.',
        rankingMinOptions: 'This question must have at least two options.',
        multipleChoiceOptionEmpty: 'Every option must have a label.',
        multipleChoiceOptionDuplicate: 'Options must be unique. Please remove the duplicate.',
        satisfactionLabelRequired: 'Every satisfaction label is required.',
    },
    message: {
        questionDeleted: 'Question has been deleted.',
        questionUpdated: 'Question has been updated.',
        questionCreated: 'Question has been added.',
        noQuestions:
            'There are no active questions in the questionnaire. Please add at least one question.',
    },
    draftSavedAt: 'Draft Saved on {{time}}',
    saveSurveyButton: 'Save Evaluation',
};
